import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IVehicleAddress } from '../../interfaces/task-info';

@Component({
  selector: 'vehicle-address',
  templateUrl: './vehicle-address.component.html',
  styleUrls: ['./vehicle-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleAddressComponent implements OnInit {
  @Input() styleClass: string = '';

  @Input() vehicleAddress: IVehicleAddress;

  public get addressLines(): string[] {
    return this.vehicleAddress.primaryAddress.replace(this.vehicleAddress.postcode, '').split(',');
  }

  constructor() {}

  ngOnInit(): void {}
}
